import { GetServerSidePropsContext } from 'next';
import { DynamicPageProps } from '~/pages/[[...slug]]';
import { getIsInitialLoad } from '~/templates/pages/utils/isInitialLoad';
import { dehydrate, QueryClient } from 'react-query';
import { DynamicPage, productDataFetcher } from '~/templates/pages';
import { staticDataResolver } from '~/templates/pages/utils';
import { dataPreFetcher, getHeaders, handleSSRResponse } from '~/templates/pages/utils/dataFetcher';

export default function ProductDetailPage(props: DynamicPageProps) {
    return <DynamicPage {...props} />;
}

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const { req, res, locale = '', resolvedUrl, params } = context;

    // Extract parameters from the URL
    const productId = (params?.productId as string) || '';
    const variantId = (params?.variantId as string) || '';

    const { host = '' } = req.headers;
    const queryClient = new QueryClient();
    const isInitialLoad = getIsInitialLoad(context);

    const headers = await getHeaders(req);

    const { page, frame, franchise } = await dataPreFetcher({
        host,
        locale,
        headers,
        queryClient,
        path: '/p',
    });

    const { settings } = staticDataResolver({ franchise, frame, headers, isInitialLoad });
    const { queryKey, franchiseAPIPath } = franchise;

    const product = await productDataFetcher({
        productId,
        productColorId: variantId,
        franchiseAPIPath,
        queryKey,
        queryClient,
        headers,
    });

    // Handle SSR response logic (headers, redirects, status codes, cache-control)
    const ssrResult = handleSSRResponse({
        res,
        pageResponse: page,
        status: product?.statusCode || 200,
        resolvedUrl,
    });

    if (ssrResult?.redirect) {
        return ssrResult;
    }


    const dehydratedState = dehydrate(queryClient);
    // Clear the cache to avoid high memory consumption on server
    queryClient.clear();

    return {
        props: {
            dehydratedState,
            franchise,
            settings,
            pageBaseUrl: host?.includes('local') ? `http://${host}` : `https://${host}`,
            resolvedUrl,
            page: page?.data,
            locale,
        },
    };
};
